define('shared/remote/payment/utils',[],function(){
    return {
        normalizeOffers: function(offers){
            var ret;
            if (Array.isArray(offers)) {
                for(var l = offers.length; l--;) {
                    offers[l] = offers[l] >> 0;
                }
                ret = offers;
            }
            else {
                ret = [offers >> 0];
            }
            return ret;
        }
    };
});
